import { NestedActionContainer } from '@eventbrite/marmalade';
import React from 'react';
import '../EventCardShared.scss';
import './VerticalEventCard.scss';

interface VerticalEventCardProps {
    isRaised?: boolean;
}

const ELEVATION =
    '0px 2px 8px rgba(30, 10, 60, 0.06), 0px 4px 12px rgba(30, 10, 60, 0.08)';

export const VerticalEventCard: React.FunctionComponent<
    VerticalEventCardProps
> = (props) => {
    const elevation = props.isRaised ? ELEVATION : undefined;

    return (
        <NestedActionContainer
            tokens={{
                '--ContainerElevation': elevation,
            }}
            className="event-card event-card__vertical"
        >
            {props.children}
        </NestedActionContainer>
    );
};
